import { t } from 'localization'

const TP = 'account.utils.orderStatusMap'

export const OrderStatusMap = (): { [k: string]: string } => ({
  awaiting_fc_review: t(`${TP}.processing`, 'Processing'),
  awaiting_payment: t(`${TP}.ordered`, 'Ordered'),
  buyer_confirmed: t(`${TP}.completed`, 'Completed'),
  buyer_rejected: t(`${TP}.orderIssues`, 'Order Issue'),
  buyer_return_approved: t(`${TP}.returnApproved`, 'Return Approved'),
  buyer_return_approved_product_missing_data: t(`${TP}.return`, 'Return'),
  buyer_return_received: t(`${TP}.orderReturned`, 'Order Returned'),
  buyer_return_rejected: t(`${TP}.returnRejected`, 'Return Rejected'),
  canceled_by_buyer: t(`${TP}.canceled`, 'Canceled'),
  canceled_by_seller: t(`${TP}.canceled`, 'Canceled'),
  canceled_by_seller_review: t(`${TP}.orderConfirmed`, 'Order Confirmed'),
  capturing_payment: t(`${TP}.ordered`, 'Ordered'),
  claim_accepted: t(`${TP}.claimApproved`, 'Claim Approved'),
  claim_filed: t(`${TP}.claimFiled`, 'Claim Filed'),
  claim_pending: t(`${TP}.claimProcessing`, 'Claim Processing'),
  claim_rejected: t(`${TP}.claimRejected`, 'Claim Rejected'),
  delivered: t(`${TP}.delivered`, 'Delivered'),
  delivered_forwarder: t(`${TP}.shippedToYou`, 'Shipped to You'),
  delivered_goat: t(`${TP}.deliveredToFlightClub`, 'Delivered to Flight Club'),
  fraudulent: t(`${TP}.canceled`, 'Canceled'),
  goat_acquired: t(`${TP}.returnedApproved`, 'Returned Approved'),
  goat_check: t(`${TP}.processing`, 'Processing'),
  goat_consigned: t(`${TP}.inStorage`, 'In Storage'),
  goat_find: t(`${TP}.deliveredToFlightClub`, 'Delivered to Flight Club'),
  goat_issue: t(`${TP}.deliveredToFlightClub`, 'Delivered to Flight Club'),
  goat_issue_buyer_accepted: t(`${TP}.orderIssue`, 'Order Issue'),
  goat_issue_resolved: t(`${TP}.refundIssued`, 'Refund Issued'),
  goat_issue_return_to_buyer: t(`${TP}.returnRejected`, 'Return Rejected'),
  goat_issue_return_to_seller: t(`${TP}.orderIssue`, 'Order Issue'),
  goat_loss: t(`${TP}.shipmentDelay`, 'Shipment Delay'),
  goat_packaged: t(`${TP}.verified`, 'Verified'),
  goat_pick: t(`${TP}.deliveredToFlightClub`, 'Delivered to Flight Club'),
  goat_prepackaged: t(`${TP}.processing`, 'Processing'),
  goat_received: t(`${TP}.deliveredToFlightClub`, 'Delivered to Flight Club'),
  goat_review: t(`${TP}.ordered`, 'Ordered'),
  goat_review_risk_rejected: t(`${TP}.ordered`, 'Ordered'),
  goat_review_skipped: t(`${TP}.ordered`, 'Ordered'),
  goat_stand_by: t(`${TP}.processing`, 'Processing'),
  goat_verified: t(`${TP}.verified`, 'Verified'),
  goat_verifying: t(`${TP}.deliveredToFlightClub`, 'Delivered to Flight Club'),
  goat_with_courier: t(`${TP}.shippedToYou`, 'Shipped to You'),
  pending: t(`${TP}.processing`, 'Processing'),
  processing_payment: t(`${TP}.ordered`, 'Ordered'),
  seller_confirmed: t(`${TP}.orderConfirmed`, 'Order Confirmed'),
  seller_packaging: t(`${TP}.orderConfirmed`, 'Order Confirmed'),
  seller_repackaging: t(`${TP}.processing`, 'Processing'),
  shipped_buyer: t(`${TP}.shippedToYou`, 'Shipped to You'),
  shipped_forwarder: t(`${TP}.shipped`, 'Shipped'),
  shipped_goat: t(`${TP}.shippedToFlightClub`, 'Shipped to Flight Club'),
  sold: t(`${TP}.purchased`, 'Purchased'),
  undeliverable: t(`${TP}.orderIssue`, 'Order Issue'),
  with_courier: t(`${TP}.shippedToFlightClub`, 'Shipped to Flight Club'),
})
